var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_394",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28874",
    "data-name": "Group 28874",
    transform: "translate(-4833 6306)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4833, -6306)",
    filter: "url(#Ellipse_394)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_394-2",
    "data-name": "Ellipse 394",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_9_",
    "data-name": "svgexport-17 (9)",
    transform: "translate(4805.985 -6290.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49726",
    "data-name": "Path 49726",
    d: "M76.817,17.184a13.394,13.394,0,0,0-7.607-3.252,13.389,13.389,0,0,0,7.573-3.249,3.885,3.885,0,0,0,0-5.493,4.015,4.015,0,0,0-2.634-1.02.424.424,0,0,1-.4-.4,4.021,4.021,0,0,0-1.02-2.635,3.884,3.884,0,0,0-5.492,0,13.408,13.408,0,0,0-3.271,7.828A13.408,13.408,0,0,0,60.7,1.139a3.884,3.884,0,0,0-5.492,0,4.021,4.021,0,0,0-1.02,2.635.424.424,0,0,1-.4.4,4.015,4.015,0,0,0-2.634,1.02,3.88,3.88,0,0,0,0,5.493,13.391,13.391,0,0,0,7.588,3.25,13.391,13.391,0,0,0-7.588,3.25,3.885,3.885,0,0,0,0,5.493,4.015,4.015,0,0,0,2.634,1.02.424.424,0,0,1,.4.4,4.021,4.021,0,0,0,1.02,2.635,3.884,3.884,0,0,0,5.492,0,12.768,12.768,0,0,0,2.545-4.384A33.386,33.386,0,0,0,65.1,29.222a11.611,11.611,0,0,0,3.066,4.552,7.818,7.818,0,0,0,1.05.812.9.9,0,1,0,.96-1.531,6.027,6.027,0,0,1-.8-.624,9.794,9.794,0,0,1-2.583-3.843,34.778,34.778,0,0,1-1.416-4.705,11.857,11.857,0,0,0,1.9,2.845,3.885,3.885,0,0,0,5.493,0,4.015,4.015,0,0,0,1.02-2.634.424.424,0,0,1,.4-.4,4.021,4.021,0,0,0,2.635-1.02,3.884,3.884,0,0,0,0-5.492ZM66.1,13.992a2.346,2.346,0,0,0-2.022,2.022q-.067.51-.1,1.024-.03-.514-.1-1.025a2.346,2.346,0,0,0-2.022-2.022c-.178-.023-.353-.042-.527-.059.174-.016.35-.035.527-.059a2.344,2.344,0,0,0,1.609-.969l.006-.008a2.34,2.34,0,0,0,.407-1.045c.034-.263.06-.521.08-.776.019.255.045.513.08.776a2.346,2.346,0,0,0,2.022,2.022c.184.024.366.044.546.06C66.446,13.951,66.275,13.97,66.1,13.992Z",
    transform: "translate(-0.001 -0.001)",
    fill: "#5eac24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49727",
    "data-name": "Path 49727",
    d: "M249.549,280.389a.9.9,0,0,1-1.246.286,7.783,7.783,0,0,1-1.049-.812,11.611,11.611,0,0,1-3.066-4.552,37.754,37.754,0,0,1-1.461-4.781,17.288,17.288,0,0,1-.542-5.682.9.9,0,0,1,1.8.1c-.006.1-.453,3.313,1.774,9.411.038.106.078.213.118.32a9.793,9.793,0,0,0,2.583,3.843,6.087,6.087,0,0,0,.8.624.9.9,0,0,1,.285,1.245Z",
    transform: "translate(-179.092 -246.09)",
    fill: "#6dc82a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49728",
    "data-name": "Path 49728",
    d: "M245.762,274.358a13.819,13.819,0,0,1-2.225-5.229.233.233,0,0,0-.457,0,13.6,13.6,0,0,1-.354,1.4,17.288,17.288,0,0,1-.542-5.682.9.9,0,0,1,1.8.1c-.006.1-.453,3.313,1.774,9.411Z",
    transform: "translate(-179.091 -246.091)",
    fill: "#5eac24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49729",
    "data-name": "Path 49729",
    d: "M255.266,11.853a2.346,2.346,0,0,0,2.022,2.022A13.54,13.54,0,0,0,268,10.683a3.885,3.885,0,0,0,0-5.493,4.015,4.015,0,0,0-2.634-1.02.424.424,0,0,1-.4-.4,4.021,4.021,0,0,0-1.02-2.635,3.884,3.884,0,0,0-5.492,0A13.54,13.54,0,0,0,255.266,11.853Z",
    transform: "translate(-191.219 -0.001)",
    fill: "#6dc82a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49730",
    "data-name": "Path 49730",
    d: "M265.114,4.068,255.671,12.9h0a2.34,2.34,0,0,1-.407-1.045,13.541,13.541,0,0,1,3.192-10.714,3.884,3.884,0,0,1,5.188-.274,3.958,3.958,0,0,1,.3.274,4.022,4.022,0,0,1,1.02,2.635.417.417,0,0,0,.147.295Z",
    transform: "translate(-191.217 0)",
    fill: "#4e901e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49731",
    "data-name": "Path 49731",
    d: "M63.889,11.853a2.339,2.339,0,0,1-.407,1.045l-.006.008a2.344,2.344,0,0,1-1.609.969,13.54,13.54,0,0,1-10.713-3.192,3.88,3.88,0,0,1,0-5.493,4.015,4.015,0,0,1,2.634-1.02.424.424,0,0,0,.4-.4,4.021,4.021,0,0,1,1.02-2.635,3.884,3.884,0,0,1,5.492,0A13.541,13.541,0,0,1,63.889,11.853Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#4e901e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49732",
    "data-name": "Path 49732",
    d: "M70.058,11.853a2.339,2.339,0,0,1-.407,1.045l-.006.008a15.612,15.612,0,0,1-11.7-3.938,4.714,4.714,0,0,1-1.312-2.846,3.878,3.878,0,0,1,.688-.931,4.015,4.015,0,0,1,2.634-1.02.424.424,0,0,0,.4-.4,4.021,4.021,0,0,1,1.02-2.635,3.884,3.884,0,0,1,5.492,0A13.541,13.541,0,0,1,70.058,11.853Z",
    transform: "translate(-6.171 -0.001)",
    fill: "#5eac24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49733",
    "data-name": "Path 49733",
    d: "M119.168,11.853a2.339,2.339,0,0,1-.407,1.045l-9.444-8.829a.417.417,0,0,0,.147-.295,4.021,4.021,0,0,1,1.02-2.635,3.884,3.884,0,0,1,5.492,0A13.541,13.541,0,0,1,119.168,11.853Z",
    transform: "translate(-55.281 -0.001)",
    fill: "#6dc82a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49734",
    "data-name": "Path 49734",
    d: "M272.375,15.846l-9.443,8.828a17.139,17.139,0,0,1,4.209-10.589,4.942,4.942,0,0,1,3.764-1.444,3.964,3.964,0,0,1,.3.274,4.021,4.021,0,0,1,1.02,2.635A.417.417,0,0,0,272.375,15.846Z",
    transform: "translate(-198.478 -11.778)",
    fill: "#5eac24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49735",
    "data-name": "Path 49735",
    d: "M257.779,204.648a2.346,2.346,0,0,0-2.022,2.022,13.541,13.541,0,0,0,3.192,10.713,3.885,3.885,0,0,0,5.493,0,4.015,4.015,0,0,0,1.02-2.634.424.424,0,0,1,.4-.4,4.021,4.021,0,0,0,2.635-1.02,3.884,3.884,0,0,0,0-5.492A13.541,13.541,0,0,0,257.779,204.648Z",
    transform: "translate(-191.677 -190.656)",
    fill: "#6dc82a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49736",
    "data-name": "Path 49736",
    d: "M280.649,214.5l-8.828-9.443h0a2.34,2.34,0,0,1,1.045-.407,13.541,13.541,0,0,1,10.714,3.192,3.884,3.884,0,0,1,.274,5.188,3.972,3.972,0,0,1-.274.3,4.022,4.022,0,0,1-2.635,1.02A.416.416,0,0,0,280.649,214.5Z",
    transform: "translate(-206.763 -190.653)",
    fill: "#4e901e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49737",
    "data-name": "Path 49737",
    d: "M280.658,221.757l-8.828-9.443a17.139,17.139,0,0,1,10.589,4.209,4.942,4.942,0,0,1,1.444,3.764,3.953,3.953,0,0,1-.274.3,4.021,4.021,0,0,1-2.635,1.02A.416.416,0,0,0,280.658,221.757Z",
    transform: "translate(-206.773 -197.915)",
    fill: "#5eac24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49738",
    "data-name": "Path 49738",
    d: "M63.887,206.665a2.346,2.346,0,0,0-2.022-2.022,13.54,13.54,0,0,0-10.713,3.192,3.885,3.885,0,0,0,0,5.493,4.015,4.015,0,0,0,2.634,1.02.424.424,0,0,1,.4.4,4.021,4.021,0,0,0,1.02,2.635,3.884,3.884,0,0,0,5.492,0A13.541,13.541,0,0,0,63.887,206.665Zm1.377-.195c.068-.228.123-.335.095-.113A.125.125,0,0,1,65.264,206.47Z",
    transform: "translate(0 -190.651)",
    fill: "#6dc82a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49739",
    "data-name": "Path 49739",
    d: "M109.321,229.535l9.443-8.828h0a2.34,2.34,0,0,1,.407,1.045,13.541,13.541,0,0,1-3.192,10.714,3.884,3.884,0,0,1-5.188.274,3.955,3.955,0,0,1-.3-.274,4.021,4.021,0,0,1-1.02-2.635A.416.416,0,0,0,109.321,229.535Z",
    transform: "translate(-55.285 -205.738)",
    fill: "#4e901e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49740",
    "data-name": "Path 49740",
    d: "M109.321,229.544l9.443-8.828a17.139,17.139,0,0,1-4.209,10.589,4.943,4.943,0,0,1-3.764,1.444,3.963,3.963,0,0,1-.3-.274,4.021,4.021,0,0,1-1.02-2.635A.417.417,0,0,0,109.321,229.544Z",
    transform: "translate(-55.284 -205.747)",
    fill: "#5eac24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClover);
export default __webpack_public_path__ + "static/media/clover.5e94d877cf6df363ef6d6c9b4567846f.svg";
export { ForwardRef as ReactComponent };